import { useTranslation } from 'react-i18next';
import { Box, Card, withStyles, useForm } from 'vopay';
import styles from './ChangePasswordForm.module.scss';
import { buildChangePasswordRows } from './buildChangePasswordRows.helper';
import { Button } from 'UI';
import PasswordRules from './PasswordRules';

type ChangePasswordData = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export type ChangePasswordFormProps = {
  submit: (values: ChangePasswordData) => void;
  onClose: () => void;
};
const cn = withStyles(styles);

const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({ submit, onClose }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Users.UsersList.ChangePassword' });

  const changePasswordRow = buildChangePasswordRows();
  const defaultValues = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    shouldSendWelcomeEmail: true,
  };
  const { renderFormElements, ctx } = useForm<ChangePasswordData, ChangePasswordData>({
    config: changePasswordRow,
    initialValues: defaultValues,
    enableReinitialize: true,
    onSubmit: (serializedData, { resetForm }) => {
      submit(serializedData);
      resetForm();
    },
  });

  const { newPassword } = ctx.values;

  const rules = [
    { test: /[A-Z]/.test(newPassword), label: t('PasswordChecker.uppercase') },
    { test: /\d/.test(newPassword), label: t('PasswordChecker.number') },
    { test: newPassword.length >= 8, label: t('PasswordChecker.character') },
    { test: /[a-z]/.test(newPassword), label: t('PasswordChecker.lowercase') },
    { test: /[^\w]/.test(newPassword), label: t('PasswordChecker.specialCharacter') },
  ];

  const isPasswordValid = rules.every((r) => r.test);

  return (
    <div
      style={{
        width: '100%',
        flex: 1,
      }}
    >
      <form className={cn('formContainer')} onSubmit={ctx.handleSubmit}>
        <Box flx="col" gapSize="24px">
          <div className={cn('fieldContainer')}>{renderFormElements({ config: changePasswordRow })}</div>
          <Card
            style={{
              padding: '16px 24px',
              backgroundColor: '#fbfbfb',
              border: '1px solid rgba(45, 45, 45, 0.10)',
            }}
          >
            <Box flx="col">
              <PasswordRules rules={rules} title={t('PasswordChecker.title')} />
            </Box>
          </Card>
          <div className={cn('btnContainer')}>
            <Button size="standard" onClick={onClose}>
              {t('Button.cancel')}
            </Button>
            <Button type="submit" colorScheme="primary" size="standard" disabled={!ctx.isValid || !isPasswordValid}>
              {t('Button.changePassword')}
            </Button>
          </div>
        </Box>
      </form>
    </div>
  );
};

export default ChangePasswordForm;
